// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"41b93614","415":"25a4d432","509":"7cb883b5","787":"28cb0dcd","940":"4f60fea0"}[chunkId] + ".chunk.js";
};